<template>
  <div>
    <div class="container fade pt-5 show active">
      <div class="row">
        <!-- Sticky sidebar -->
        <div id="stickyBlockStartPoint" class="col-lg-3 pr-xl-5 mb-5 mb-lg-0">
          <!-- Filter -->
          <div
            class="js-sticky-block"
            data-hs-sticky-block-options="{
              &quot;parentSelector&quot;: &quot;#stickyBlockStartPoint&quot;,
              &quot;breakpoint&quot;: &quot;lg&quot;,
              &quot;startPoint&quot;: &quot;#stickyBlockStartPoint&quot;,
              &quot;endPoint&quot;: &quot;#stickyBlockEndPoint&quot;,
              &quot;stickyOffsetTop&quot;: 16
              }"
          >
            <div class="navbar-expand-lg navbar-expand-lg-collapse-block">
              <!-- Responsive Toggle Button -->
              <button v-b-toggle.apiBrandedReadmeSidebarNav class="navbar-toggler btn btn-block border py-3">
                <span class="d-flex justify-content-between align-items-center">
                  <span class="h5 mb-0">{{ $t('M08d-02-mobile') }}</span>
                  <span class="navbar-toggler-default">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z" />
                    </svg>
                  </span>
                  <span class="navbar-toggler-toggled">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                      <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
                    </svg>
                  </span>
                </span>
              </button>
              <!-- End Responsive Toggle Button -->
              <b-collapse id="apiBrandedReadmeSidebarNav" class="navbar-collapse">
                <div class="mt-5 mt-lg-0">
                  <!-- Nav Link -->
                  <div class=" overview-container">
                    <a class="dropdown-item d-flex justify-content-between align-items-center px-0 cursor-pointer" @click="goToProviderGuides">
                      {{ $t('M08d-02') }}
                    </a>
                    <a v-if="apiInfo && apiInfo[0]" class="dropdown-item d-flex justify-content-between align-items-center mt-4 px-0 disabled theme-link">
                      {{ apiInfo[0].api_name }}
                    </a>
                  </div>
                  <!-- End Nav Link -->
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
        <!-- End Sticky Sidebar -->

        <!-- Main Guides Section -->
        <div id="scroll-to-div" class="col-lg-9 mb-5 mb-lg-0">
          <Readme ref="readme" :guides="guides" :lastUpdateDate="lastUpdateDate" from="api" :apiName="api_name" :themeColor="themeColor" :noInfoMessage="$t('err-specific-01-01')" />
        </div>
      </div>
      <!-- End Main Guides Section -->

      <!-- Sticky Block End Point -->
      <div id="stickyBlockEndPoint" />
      <div class="space-top-2" />
    </div>
  </div>
</template>

<script>
const $ = require('jquery')
import HSStickyBlock from '@/assets/vendor/hs-sticky-block/src/js/hs-sticky-block'
import Readme from '@/components/readme'
import apiInfoMixin from '@/mixins/api-info'

export default {
  name: 'ApiInfoBrandedReadme',
  components: {
    Readme
  },
  mixins: [apiInfoMixin],
  props: {
    guides: {
      type: String,
      default: ''
    },
    lastUpdateDate: {
      type: String,
      default: ''
    },
    themeColor: {
      type: String,
      default: '#57ABF0'
    }
  },
  data() {
    return {
      headings: [],
      loaded: false,
      api_name: this.apiInfo[0] && this.apiInfo[0].api_name ? this.apiInfo[0]?.api_name : ''
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    }
  },
  watch: {
    async userProfile() {
      await this.initialise()
    },
    loaded() {
      if (this.loaded) {
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$router.currentRoute.hash !== '') {
              this.$router.push({
                name: 'api-info',
                params: {
                  provider_name: this.$route.params.provider_name,
                  api_name: this.$route.params.api_name,
                  tab_name: this.$route.params.tab_name
                },
                hash: this.$route.hash
              })
              this.scrollToSection(this.$router.currentRoute.hash.replace('#', ''))
            }
          })
        })
      }
    }
  },
  mounted() {
    new HSStickyBlock($('.js-sticky-block')).init()
  },
  async created() {
    await this.initialise()
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      this.$nextTick(() => {
        this.loaded = true
        this.$store.dispatch('app/setLoading', false)
      })
    },
    goToProviderGuides() {
      this.$router.push({
        name: 'provider-info-branded',
        params: {
          provider_name: this.$route.params.provider_name,
          tab_name: 'guides'
        }
      })
    },
    scrollToSection(elementID) {
      document.getElementById(elementID) !== null ? document.getElementById(elementID).scrollIntoView({ behavior: 'smooth' }) : null
    }
  }
}
</script>

<style lang="scss" scoped>
.overview-container .dropdown-item {
  white-space: normal;
}
.sidebar-icons {
  font-size: 10px;
  padding-right: 8px;
}
</style>
